import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCopy, faHashtag, faImage, faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { add_fund_request,msgPromtsuccess } from "../../features/userSlice";
import { useT } from "../../i18n";

const AddFundManual = () => {
    const [amount, setAmount] = useState("");
    const [utr, setUtr] = useState("");
    const dispatch = useDispatch();
    const { t } = useT();
    const { Info } = useSelector((state) => state.users);
    const [image, setImage] = useState(null);

    const payeeAddress = Info?.UPI_ADMIN;
    const handleCopy = () => {
      navigator.clipboard.writeText(payeeAddress);
      dispatch(msgPromtsuccess({msg:`UPI copied to clipboard!`,error:false}));
     // alert(`${text} copied to clipboard!`);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
          setImage(file);
        } else {
          dispatch(msgPromtsuccess({msg:"Please select a valid image file.",error:true}));
        }
      };
    
  
    const handleSubmit = (e) => {
      e.preventDefault();
      // if (!image) {
      //   dispatch(msgPromtsuccess({msg:"Please select an image first.",error:true}));
      //   return;
      // }
      if (!amount) {
        dispatch(msgPromtsuccess({msg:"Please Enter Amount first.",error:true}));
        return;
      }
      if (!utr) {
        dispatch(msgPromtsuccess({msg:"Please Enter UTR first.",error:true}));
        return;
      }
      let data = new FormData();
      data.append('phone_number',Info?.phone_number);
      data.append('amount', amount);
      data.append('UTR_NUM',utr );
      data.append('image',image );
      dispatch(add_fund_request(data));
    };
    
    const fileInputRef = useRef(null);

  // Function to trigger the file input click
  const handleDivClick = () => {
    // Trigger the file input click when the div is clicked
    fileInputRef.current.click();
  };

return (
        <form className="af-screen" onSubmit={handleSubmit}>
            <div>
                <h2 className="af-title">{t("Manual Deposit")}</h2>
                <p className="af-hint" style={{margin:'4px 0 0'}}>{t('Pay to the UPI ID below, then enter the UTR number and upload the payment screenshot.')}</p>
            </div>

            <label className="af-label" htmlFor="manual-amount">{t("Amount")}</label>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faIndianRupeeSign} /></i>
                <input id="manual-amount" className="input_lable_deep" type="number" inputMode="numeric" value={amount} onChange={(e)=>setAmount(e.target.value)} placeholder={t("Enter amount")} />
            </div>

            {parseInt(amount) && payeeAddress ? (
                <div className="mf-upi">
                    <div>
                        <span>{t('Pay to UPI ID')}</span>
                        <strong>{payeeAddress}</strong>
                    </div>
                    <button type="button" className="mf-copy" onClick={handleCopy}><FontAwesomeIcon icon={faCopy} /> {t('Copy')}</button>
                </div>
            ) : null}

            <label className="af-label" htmlFor="manual-utr">{t("UTR Number")}</label>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faHashtag} /></i>
                <input id="manual-utr" className="input_lable_deep" type="number" inputMode="numeric" value={utr} onChange={(e)=>setUtr(e.target.value)} placeholder={t("Enter 12-digit UTR number")} />
            </div>

            <span className="af-label">{t("Payment Screenshot")} <em className="mf-optional">({t("optional")})</em></span>
            <button type="button" className="mf-upload" onClick={handleDivClick}>
                <span className="mf-upload-icon"><FontAwesomeIcon icon={image ? faCircleCheck : faImage} /></span>
                <strong>{image ? image.name : t('Tap to upload screenshot')}</strong>
                <span>{image ? t('Tap to change') : t('PNG or JPG')}</span>
            </button>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleImageChange}
                accept="image/*"
            />

            <button type="submit" className="continue-button">{t("Submit")}</button>
        </form>
    );
};

export default AddFundManual;
